module.exports = __webpack_public_path__ + "static/media/Paypal-Payment-Logo.d97c03f0.png";